<section class="order-container" id="mplpasiva-order">
  <div class="row">
    <div class="row">
      <div class="left">
        <div class="title-name">Títulos</div>
      </div>
      <div class="right">
        <div class="title-name disabled">Duración</div>
      </div>
    </div>
    <div
      punchPicker
      [placeholder]="'Títulos'"
      [isTitles]="true"
      (items)="setTitles($event)"
      [sentValue]="titles"
      [minValue]="minTitles"
      data-recording-sensitive
    ></div>
    <div class="hard-section">
      <div class="subtitle">1 día</div>
    </div>
  </div>
  <div class="row">
    <div class="row">
      <div class="left">
        <div class="title-name">Puja</div>
      </div>
      <div class="right max-price">
        <div class="title-name">Precio Máximo</div>
      </div>
    </div>
    <div
      class="puja"
      class="puja"
      [maxValue]="900"
      [minValue]="1"
      [placeholder]="'Puja'"
      punchPicker
      (items)="setPuja($event)"
    ></div>
    <div
      class="prc-max"
      class="prc-max"
      [placeholder]="'Prc. máximo'"
      punchPicker
      [sentValue]="selectedPrice"
      [isPrice]="true"
      (items)="setMaxPrice($event)"
      [minValue]="0"
      data-recording-sensitive
    ></div>
  </div>

  <div class="actions" *ngIf="canOperate && !isDiscretional">
    <button (click)="tryBuy()" class="btn-compra">
      <div class="button button--loading" *ngIf="isBuyButtonLoading">
        <div class="button__loader">
          <div class="dot"></div>
          <div class="dot"></div>
          <div class="dot"></div>
        </div>
      </div>
      {{ isBuyButtonLoading ? '' : 'Comprar' }}
    </button>
    <button (click)="trySell()" class="btn-venta">
      <div class="button button--loading" *ngIf="isSellButtonLoading">
        <div class="button__loader">
          <div class="dot"></div>
          <div class="dot"></div>
          <div class="dot"></div>
        </div>
      </div>
      {{ isSellButtonLoading ? '' : 'Vender' }}
    </button>
  </div>
</section>

<app-confirmation-modal
  [order]="confirmationOrder"
  (onClose)="cancelConfirmation()"
  (confirmationHandler)="registerOrder()"
  *ngIf="showConfirmation"
>
</app-confirmation-modal>
